import { ApiException, ErrorCode } from 'mh-client';

export { ErrorCode };

/**
 * Check if a caught error is an ApiException with a specific error code.
 */
export function hasErrorCode(error: unknown, code: ErrorCode): boolean {
    return error instanceof ApiException && error.error.code === code;
}
